import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "7362f055-0bc0-4087-add7-907590e69718",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "The reverberation radius of the room (use room constant): r<sub>H</sub> = ",
    suffixText: "m",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 1.88,
};
